export default "__VITE_ASSET__Bwv5jB2s__"